import { render } from "./ProfileChanged.vue?vue&type=template&id=098b6722"
import script from "./ProfileChanged.vue?vue&type=script&lang=js"
export * from "./ProfileChanged.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__